import { lazy, Suspense } from "react";
import { createBrowserRouter, Navigate, Outlet } from "react-router-dom";
import { useAuth } from "./auth";
import { AppShell } from "@/components/layout/AppShell";
import LoginPage from "@/pages/Login";
import SetPasswordPage from "@/pages/SetPassword";
import ForgotPasswordPage from "@/pages/ForgotPassword";
import { pendingAuthLink } from "./auth-links";
import DashboardPage from "@/pages/Dashboard";
import ConsolePage from "@/pages/Console";
import ClientsPage from "@/modules/clients/ClientsPage";
import ClientPage from "@/modules/clients/ClientPage";
import CataloguePage from "@/modules/catalogue/CataloguePage";
import QuotesPage from "@/modules/quotes/QuotesPage";
import QuoteEditorPage from "@/modules/quotes/QuoteEditorPage";
import QuotePage from "@/modules/quotes/QuotePage";
import OrdersPage from "@/modules/orders/OrdersPage";
import OrderPage from "@/modules/orders/OrderPage";
import SettingsPage from "@/modules/settings/SettingsPage";
const PublicQuotePage = lazy(() => import("@/pages/public/PublicQuotePage"));
import LeadsPage from "@/modules/leads/LeadsPage";
import DisputePage from "@/modules/disputes/DisputePage";
import InvoicesPage from "@/modules/invoices/InvoicesPage";
import InvoicePage from "@/modules/invoices/InvoicePage";
import InvoiceEditorPage from "@/modules/invoices/InvoiceEditorPage";
const PublicPayPage = lazy(() => import("@/pages/public/PublicPayPage"));
const PublicSignPage = lazy(() => import("@/pages/public/PublicSignPage"));
import BankPage from "@/modules/bank/BankPage";
import AccountingPage from "@/modules/accounting/AccountingPage";
import ContractsPage from "@/modules/contracts/ContractsPage";
import ContractPage from "@/modules/contracts/ContractPage";
import ContractEditorPage from "@/modules/contracts/ContractEditorPage";

function RequireAuth() {
  const { session, loading, rolesLoading } = useAuth();
  if (loading || (session && rolesLoading)) return <div className="flex h-screen items-center justify-center text-muted-foreground">Chargement…</div>;
  if (!session) return <Navigate to="/connexion" replace />;
  // Arrivé par un lien d'invitation ou de réinitialisation : le mot de passe
  // doit être choisi avant tout accès au CRM.
  const pending = pendingAuthLink();
  if (pending === "invite" || pending === "recovery") return <Navigate to="/definir-mot-de-passe" replace />;
  return <AppShell><Outlet /></AppShell>;
}

export const router = createBrowserRouter([
  { path: "/connexion", element: <LoginPage /> },
  { path: "/mot-de-passe-oublie", element: <ForgotPasswordPage /> },
  { path: "/definir-mot-de-passe", element: <SetPasswordPage /> },
  { path: "/p/devis/:token", element: <Suspense fallback={<div className="p-8 text-sm text-muted-foreground">Chargement…</div>}><PublicQuotePage /></Suspense> },
  { path: "/p/signer/:token", element: <Suspense fallback={<div className="p-8 text-sm text-muted-foreground">Chargement…</div>}><PublicSignPage /></Suspense> },
  { path: "/p/payer/:token", element: <Suspense fallback={<div className="p-8 text-sm text-muted-foreground">Chargement…</div>}><PublicPayPage /></Suspense> },
  {
    element: <RequireAuth />,
    children: [
      { path: "/", element: <DashboardPage /> },
      { path: "/clients", element: <ClientsPage /> },
      { path: "/clients/:id", element: <ClientPage /> },
      { path: "/catalogue", element: <CataloguePage /> },
      { path: "/devis", element: <QuotesPage /> },
      { path: "/devis/nouveau", element: <QuoteEditorPage /> },
      { path: "/devis/:id", element: <QuotePage /> },
      { path: "/devis/:id/modifier", element: <QuoteEditorPage /> },
      { path: "/contrats", element: <ContractsPage /> },
      { path: "/contrats/:id", element: <ContractPage /> },
      { path: "/contrats/:id/modifier", element: <ContractEditorPage /> },
      { path: "/commandes", element: <OrdersPage /> },
      { path: "/commandes/:id", element: <OrderPage /> },
      { path: "/leads", element: <LeadsPage /> },
      { path: "/contestations/:id", element: <DisputePage /> },
      { path: "/factures", element: <InvoicesPage /> },
      { path: "/factures/:id", element: <InvoicePage /> },
      { path: "/factures/:id/modifier", element: <InvoiceEditorPage /> },
      { path: "/banque", element: <BankPage /> },
      { path: "/comptabilite", element: <AccountingPage /> },
      { path: "/console", element: <ConsolePage /> },
      { path: "/parametres", element: <SettingsPage /> },
      { path: "*", element: <Navigate to="/" replace /> },
    ],
  },
]);
